var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerminology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8549 19.2863H4.28348C3.71516 19.2863 3.17012 19.0605 2.76825 18.6586C2.36639 18.2568 2.14063 17.7117 2.14062 17.1434C2.14063 16.5751 2.36639 16.0301 2.76825 15.6282C3.17012 15.2263 3.71516 15.0006 4.28348 15.0006H16.4263M16.4263 15.0006C16.8052 15.0006 17.1686 14.85 17.4365 14.5821C17.7044 14.3142 17.8549 13.9509 17.8549 13.572V2.14342C17.8549 1.76453 17.7044 1.40117 17.4365 1.13326C17.1686 0.865354 16.8052 0.714844 16.4263 0.714844H4.28348C3.72492 0.714645 3.18836 0.932549 2.7881 1.32214C2.38784 1.71172 2.15552 2.2422 2.14062 2.80056V17.0863M16.4263 15.0006V19.2863",
    stroke: "#495057",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4999 7.14653H14.8085L11.2942 12.108H15.0142M5.01562 8.55225L6.53848 3.98225C6.57633 3.86822 6.64916 3.76902 6.74661 3.69875C6.84407 3.62848 6.96119 3.59071 7.08134 3.59082C7.32848 3.59082 7.54848 3.74796 7.62705 3.98225L9.14991 8.55225M5.56705 6.89796H8.59848",
    stroke: "#495057",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminology);
export default __webpack_public_path__ + "static/media/terminology.4d0c8863297b79a588955a854a525388.svg";
export { ForwardRef as ReactComponent };